/* eslint-disable import/prefer-default-export */
import { fetchStudentAssignments } from 'a/api/fluencyStudentAssignments';
import { getSelectedProduct } from 'a/selectors/appSessionSelectors';
import { setFluencyAssignment, setFluencyVisited } from 'a/boostFluency/redux/actions';
import { FLUENCY_VISITED_SESSION_KEY, FLUENCY_COMPLETED_SESSION_KEY } from 'a/boostFluency/data/constants';
import { devLog } from 'lib/utilityFunctions';
import { PRODUCT_READING } from 'lib/constants';

export const fetchFluencyAssignments = () => async (dispatch, getState) => {
  const state = getState();
  const selectedProduct = getSelectedProduct(state);
  // A student who already completed a passage this session stays gated out until
  // a new session starts (tab close / new login). Skip the fetch so a page refresh
  // can't hand back the next in-progress assignment.
  // sessionStorage is stringly-typed: compare against 'true' explicitly so a stray
  // value (e.g. 'false') can't gate a student out via a truthiness check.
  // TODO: selectedProduct !== PRODUCT_READING is a temp product guard;
  // revisit once multi-product fluency support is fully defined.
  const completed = sessionStorage.getItem(FLUENCY_COMPLETED_SESSION_KEY) === 'true';
  if (completed || selectedProduct !== PRODUCT_READING) {
    dispatch(setFluencyAssignment(null));
    return;
  }
  let assignment = null;
  try {
    const assignments = await fetchStudentAssignments();
    // take the first assignment if it exists, otherwise null (which indicates no assignment)
    // the next assignment will be handled upon completion of the current assignment and re-fetching the list
    assignment = assignments[0] ?? null;
    dispatch(setFluencyAssignment(assignment));
  } catch (error) {
    devLog('[fetchFluencyAssignments] Failed to load assignment');
    dispatch(setFluencyAssignment(null));
  }

  // Mark visited on fetch if we persisted it earlier this session — the student
  // already clicked through the launch modal, so the first-time onboarding
  // treatment shouldn't fire again on a page refresh within the same session.
  if (sessionStorage.getItem(FLUENCY_VISITED_SESSION_KEY) === 'true') {
    dispatch(setFluencyVisited());
  }
};
